import "./style.scss";
import Logo from "../../image/LogoSvg.png";
import { toast } from "sonner";

import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components";
import { useParams } from "react-router-dom";

interface Otp {
  first: string;
  second: string;
  third: string;
  fourth: string;
  fifth: string;
  sixth: string;
}
export default function Verification() {
  const { email } = useParams();
  console.log(email);
  const navigate = useNavigate();
  const [otp, setOtp] = useState<Otp>({
    first: "",
    second: "",
    third: "",
    fourth: "",
    fifth: "",
    sixth: "",
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

  useEffect(() => {
    inputRefs.current[0]?.focus();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const { name, value } = e.target;

    if (value.length > 1 || (value && !/^[0-9]$/.test(value))) return;

    setOtp({ ...otp, [name]: value });

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === "Backspace" && !otp[Object.keys(otp)[index] as keyof Otp] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);

    if (paste.length === 6) {
      const newOtp = {
        first: paste[0],
        second: paste[1],
        third: paste[2],
        fourth: paste[3],
        fifth: paste[4],
        sixth: paste[5],
      };
      setOtp(newOtp);
      inputRefs.current[5]?.focus();
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const isComplete = Object.values(otp).every((digit) => digit !== "");
    if (!isComplete) {
      toast.error("Please enter all 6 digits");
      return;
    }
    const otpValue = Object.values(otp).join("");
    const emailValue = localStorage.getItem("email");
    const payload = { email: emailValue, OTP: otpValue };
    setIsLoading(true);

    try {
      const response = await fetch("https://core.pluritongues.com/auth/verify-otp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const data = await response.json();
        toast.success("OTP verified successfully");
        localStorage.setItem("otp", otpValue);
        navigate("/new-password");
      } else {
        const errorData = await response.json();
        toast.error(errorData.message || "Invalid OTP");
      }
    } catch (err) {
      toast.error("An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const inputFields = ["first", "second", "third", "fourth", "fifth", "sixth"].map(
    (name, index) => (
      <input
        key={name}
        type="text"
        name={name}
        placeholder=""
        value={otp[name as keyof Otp]}
        onChange={(e) => handleChange(e, index)}
        onKeyDown={(e) => handleKeyDown(e, index)}
        onPaste={handlePaste}
        className="otpField"
        maxLength={1}
        ref={(el) => (inputRefs.current[index] = el)}
        inputMode="numeric"
        pattern="[0-9]*"
        autoComplete="one-time-code"
      />
    )
  );

  return (
    <>
      <div className="forgot-password-header">
        <img className="forgot-password-logo" src={Logo} alt="logo" />
        <h1 className="forgot-password-pluritongues">Pluritongues</h1>
      </div>

      <div className="forgot-password-layout">
        <div className="forgot-password-sidebar">
          <div className="forget-password-back-arrow-wrapper" onClick={() => navigate("/")}>
            <i className="fas fa-arrow-left forget-password-back-arrow"></i>
            <div className="forgot-password-back-text">Back</div>
          </div>

          <h1>Verify OTP</h1>
          <p>Please Enter the 5 digit otp sent to your email</p>

          <form onSubmit={handleSubmit} className="forget-password-form-wrapper">
            <div className="fieldBoxOtp">{inputFields}</div>
            <Button
              variant="primary"
              className="signin_btn"
              type="submit"
              isLoading={isLoading}
              disabled={isLoading}
            >
              Reset Password
            </Button>
          </form>

          <p className="forgot-password-footer">
            &copy; right <a href="https://pluritongues.com">Pluritongues</a>. All rights reserved
          </p>
        </div>
        <div className="forgot-password-bg-body"></div>
      </div>
    </>
  );
}

//     return (
//         <div className="forgot-password-header">
//            <div>

//            </div>
//            <div>
//             <Button>Sign In<Button>
//            </div>
//         </div>

//     )
// }

{
  /* <div className="forget-password-form-wrapper">
            <div className="forget-wrapper">
            <p>Forgot password</p>
             <form className="forget-password-form" */
}
{
  /* onSubmit={handleSubmit}>
                 <label>Email</label>
                 <input 
                 type="text"
                 value={email}
                 onChange={(e) => setEmail(e.target.value)}
                 autoFocus
                  /> */
}

{
  /* {error && <p>{error}</p>}

                  <button type="submit">
                     Submit
                  </button>
             </form>
            </div> */
}

{
  /* </div> */
}
